import { useEffect, useState } from 'react';

/**
 * 仮当選の受取期限の表示。
 *
 * 期限はサーバーが決めた値（抽選から 30 分と開催終了の早い方）をそのまま見せる。
 * 端末の時計がずれていると実際の期限と食い違うため、案内は「およその残り時間」に留め、
 * 期限そのものの判定はサーバーで行う。
 */

/** 残り時間の文言。期限を過ぎていたら null（画面はサーバーの状態に従う） */
export function deadlineText(expiresAt: string): string | null {
  const remaining = Date.parse(expiresAt) - Date.now();
  if (!Number.isFinite(remaining) || remaining <= 0) return null;
  const minutes = Math.ceil(remaining / 60000);
  return minutes >= 60 ? `あと約${Math.floor(minutes / 60)}時間` : `あと約${minutes}分`;
}

/** 残り時間を定期的に更新して返す */
export function useDeadlineText(expiresAt: string): string | null {
  const [text, setText] = useState(() => deadlineText(expiresAt));

  useEffect(() => {
    setText(deadlineText(expiresAt));
    const timer = setInterval(() => setText(deadlineText(expiresAt)), 20000);
    // 端末をスリープさせていた間は更新が止まるため、戻ってきたときに読み直す
    const onVisible = (): void => {
      if (!document.hidden) setText(deadlineText(expiresAt));
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [expiresAt]);

  return text;
}
